export const CHECKOUT_URL =
  'https://decoracion-de-fiestas-y-eventos.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/hwxpUnqRc7oK2sRmQf3wNE/Imagen_de_ChatGPT_8_oct_2026,_09_57_01.png'

export const PRODUCT_NAME = 'MEGA PACK DECORACIÓN DE FIESTAS Y EVENTOS'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos sobre arcos de globos, fondos, paneles, mesas temáticas y estructuras, pero cada uno explica algo diferente y no sabes cómo conectar todo.',
  },
  {
    icon: 'question' as const,
    title: 'NO SABES QUÉ APRENDER PRIMERO',
    desc: 'Globos, guirnaldas, paneles, estructuras, pedestales, mesas, colores, presupuestos... hay tantos elementos que empezar parece complicado.',
  },
  {
    icon: 'route' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Quieres aprender a crear decoraciones completas y quizás convertir esta habilidad en un nuevo servicio, pero necesitas un camino que vaya desde la planificación hasta el montaje final.',
  },
  {
    icon: 'hourglass' as const,
    title: 'SIGUES POSTERGANDO',
    desc: 'Quieres comenzar, pero pasan las semanas y continúas guardando ideas y tutoriales en lugar de avanzar con un método organizado.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'clipboard' as const,
    title: 'FUNDAMENTOS DE DECORACIÓN Y PLANIFICACIÓN DE EVENTOS',
    desc: 'Aprende a definir el tipo de evento, temática, colores, punto focal, distribución, herramientas, materiales, medidas y planificación antes de comenzar cualquier decoración.',
  },
  {
    icon: 'party' as const,
    title: 'GLOBOS, GUIRNALDAS Y ARCOS PROFESIONALES',
    desc: 'Conoce tipos y tamaños de globos, combinaciones de colores, guirnaldas orgánicas, arcos, columnas, volumen, fijación, cantidades, transporte y terminaciones.',
  },
  {
    icon: 'frame' as const,
    title: 'FONDOS, PANELES, ESTRUCTURAS Y ESCENOGRAFÍAS',
    desc: 'Aprende a trabajar con paneles, aros, estructuras, telas, fondos florales, carteles, pedestales, iluminación y diferentes niveles para crear sectores principales completos.',
  },
  {
    icon: 'cake' as const,
    title: 'MESAS TEMÁTICAS, CANDY BAR Y DECORACIÓN INFANTIL',
    desc: 'Aprende a organizar mesas principales, candy bar, pedestales, tortas, personalizados y diferentes temáticas para cumpleaños, baby showers, bautismos, comuniones y otros eventos.',
  },
  {
    icon: 'hammer' as const,
    title: 'DISEÑO Y ARMADO DE EVENTOS COMPLETOS',
    desc: 'Comprende cómo pasar de una idea al montaje final, organizar sectores, preparar materiales, calcular tiempos, transportar estructuras y seguir un orden de armado profesional.',
  },
  {
    icon: 'calculator' as const,
    title: 'PRESUPUESTOS, COSTOS Y EMPRENDIMIENTO DE DECORACIÓN',
    desc: 'Aprende a organizar servicios, calcular materiales, transporte y mano de obra, preparar presupuestos, controlar reservas, atender clientes y estructurar tu servicio de decoración.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'palette' as const,
    title: '50 DISEÑOS Y COMBINACIONES DE COLORES PARA EVENTOS™',
    desc: '50 combinaciones listas para cumpleaños, fiestas infantiles, baby showers, bautismos, comuniones, 15 años, bodas y eventos, con paletas para globos, paneles, mesas y accesorios.',
    value: 'Valor: $7.990',
  },
  {
    icon: 'sheet' as const,
    title: 'PLANTILLAS DE PRESUPUESTOS, COSTOS Y CONTROL DE CLIENTES™',
    desc: 'Modelos prácticos para presupuestos, fichas de clientes, cálculo de costos, paquetes, reservas, pagos, compras, checklist de eventos y control de resultados.',
    value: 'Valor: $5.990',
  },
  {
    icon: 'ruler' as const,
    title: 'GUÍA DE CANTIDADES, MEDIDAS Y MATERIALES PARA GLOBOS™',
    desc: 'Una guía práctica para calcular cantidades orientativas de globos, tamaños, colores, repuestos y materiales para guirnaldas, arcos, columnas y decoraciones con paneles.',
    value: 'Valor: $6.990',
  },
  {
    icon: 'bulb' as const,
    title: '30 IDEAS DE DECORACIONES COMPLETAS™',
    desc: '30 propuestas listas para inspirarte con temáticas, colores, paneles, globos, pedestales, personalizados y detalles para diferentes tipos de eventos.',
    value: 'Valor: $8.990',
  },
  {
    icon: 'checklist' as const,
    title: 'CHECKLIST PROFESIONAL DE MONTAJE Y KIT DE EMERGENCIA™',
    desc: 'Un sistema práctico para preparar materiales, organizar el transporte, montar, revisar y desmontar cada evento, incluyendo herramientas y repuestos para resolver imprevistos.',
    value: 'Valor: $9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'compass' as const,
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre tutoriales y sigue una ruta desde la planificación hasta los globos, estructuras, mesas, montaje y presupuesto.',
  },
  {
    icon: 'book' as const,
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprende cómo combinar globos, colores, fondos, paneles, pedestales, mesas y personalizados mediante explicaciones organizadas.',
  },
  {
    icon: 'eye' as const,
    title: 'COMPRENDE CÓMO ARMAR TODO',
    desc: 'Empieza a mirar un espacio vacío y reconocer qué elementos utilizar, dónde ubicarlos y cómo combinarlos para crear una decoración completa.',
  },
  {
    icon: 'sparkles' as const,
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construye conocimientos que pueden convertirse en el primer paso para decorar tus propios eventos o comenzar a ofrecer un nuevo servicio.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Había guardado muchísimas ideas de globos y decoraciones, pero no sabía cómo combinar todo. Con los tomos ordenados finalmente entendí cómo empezar por los colores, el fondo y después organizar cada elemento.',
    author: 'Carolina Fernández',
    role: 'Emprendedora en formación, 31 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Lo que más me ayudó fue entender que decorar no es solamente hacer un arco de globos. Hay que medir, planificar el espacio, elegir estructuras y conseguir que todo tenga coherencia.',
    author: 'Mariana Ibáñez',
    role: 'Emprendedora, 38 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Quería aprender para decorar cumpleaños y quizás empezar a ofrecer el servicio, pero no sabía qué estudiar primero. El sistema me ayudó a conectar globos, paneles, mesas y presupuestos.',
    author: 'Laura Quiroga',
    role: 'Emprendedora, 34 años',
    location: 'Montevideo, Uruguay',
  },
  {
    quote:
      'Entré buscando aprender arcos de globos y terminé entendiendo también cómo planificar una decoración completa. Las ideas y combinaciones me ayudaron mucho para practicar.',
    author: 'Cristina Molina',
    role: 'Decoradora en formación, 29 años',
    location: 'Santiago, Chile',
  },
  {
    quote:
      'Quería empezar algo nuevo y necesitaba una estructura clara. Las plantillas, presupuestos y checklist me dieron una forma mucho más ordenada de practicar y preparar cada evento.',
    author: 'Andrea Ramírez',
    role: 'Emprendedora, 42 años',
    location: 'Guadalajara, México',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El contenido está organizado para comenzar desde los fundamentos y avanzar paso a paso.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Aprenderás planificación, combinación de colores, globos, guirnaldas, arcos, paneles, estructuras, mesas temáticas, montaje, presupuestos y organización de eventos.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Los contenidos incluyen ejercicios y proyectos prácticos para aplicar lo aprendido.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos con tu compra.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizas un único pago y accedes al contenido incluido.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Al confirmarse la compra recibes acceso digital al material.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es un producto educativo pensado para desarrollar conocimientos y habilidades prácticas.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Al ser contenido digital puedes avanzar según tus propios tiempos.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes comunicarte mediante nuestro canal de soporte.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Valeria Gómez', city: 'Córdoba', minutes: 3 },
  { name: 'Romina Sosa', city: 'Rosario', minutes: 6 },
  { name: 'Natalia Ruiz', city: 'Buenos Aires', minutes: 9 },
  { name: 'Florencia Paz', city: 'Mendoza', minutes: 13 },
  { name: 'Lorena Medina', city: 'La Plata', minutes: 17 },
  { name: 'Daniela Herrera', city: 'Mar del Plata', minutes: 21 },
  { name: 'Agustina Rojas', city: 'Salta', minutes: 26 },
  { name: 'Micaela Torres', city: 'San Miguel de Tucumán', minutes: 31 },
]
